// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jLAp","delete":"styles_delete__E4zch","update":"styles_update__3FIQA","add":"styles_add__2zdHH"};